export const REACT_APP_ENV = '{Environment}';
export const CHF = 'CHF';
export const USDT = 'USDT';
export const USD = 'USD';
export const MAIN_CURRENCY = USDT;
export const COMPANY_NAME = 'Trailblaze';
export const COMPANY_DOMAIN = 'https://trailblaze.xyz';
export const COMPANY_DOMAIN_SHORT = 'trailblaze.xyz';
export const COMPANY_SUPPORT_EMAIL = 'support@trailblaze.xyz';